import { Select, type SelectProps, SelectVariant } from "./Select";

export interface ChipSelectProps extends Omit<SelectProps, "isMultiSelect" | "variant"> {
  hasSearchInDropdown?: boolean;
}

export function ChipSelect({ hasSearchInDropdown = true, ...props }: ChipSelectProps): JSX.Element {
  return <Select {...props} isMultiSelect variant={SelectVariant.CHIP} hasSearchInDropdown={hasSearchInDropdown} />;
}
